// extracted by mini-css-extract-plugin
module.exports = {"rowsContainer":"Stat_rowsContainer__2PBVZ","title":"Stat_title__szExe","value":"Stat_value__3TthU"};